import { render, staticRenderFns } from "./MarketingLayout.vue?vue&type=template&id=fb428e10&scoped=true&lang=pug&"
import script from "./MarketingLayout.vue?vue&type=script&lang=js&"
export * from "./MarketingLayout.vue?vue&type=script&lang=js&"
import style0 from "./MarketingLayout.vue?vue&type=style&index=0&id=fb428e10&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb428e10",
  null
  
)

export default component.exports